var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rbv-progress-bar"},[_c('div',{staticClass:"percent",style:({width: _vm.percentage+'%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }